import ApiDispatcher from 'api/api-dispatcher'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import useForceUpdate from 'hooks/useForceUpdate'

const ModelContainer = ({ children, modelId }) => {
  const [state, setState] = useState({})
  const mountedRef = useRef(true)
  const forceUpdate = useForceUpdate()

  const cachedModel = App.state.entities[modelId]

  useEffect(() => {
    loadModel()
    return () => {
      mountedRef.current = false
    }
  }, [])

  useEffect(() => {
    loadModel()
  }, [modelId])

  const loadModel = async () => {
    if (state.loadingModelId == modelId)
      return

    let cached = cachedModel
    if (cached)
      forceUpdate()
    if (!cached || cached.needsReloading) {
      setState({ loadingModelId: modelId })
      await ApiDispatcher.loadModel(modelId)
      if (mountedRef.current !== false) setState({ loadingModelId: null })
    }
  }

  return children(cachedModel)
}

ModelContainer.propTypes = {
  modelId: PropTypes.string
}

export default ModelContainer
